import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AnalysisStateService } from '../services/analysis-state.service';

@Injectable({ providedIn: 'root' })
export class ClearAnalysisResolve implements Resolve<void> {
	constructor(private readonly analysisStateService: AnalysisStateService) {}

	resolve() {
		this.analysisStateService.update(null);
	}
}
